package com.eladfinish.bible.contest.ui.components.toolbar.configuration.model

import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.automirrored.filled.ExitToApp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.ic_launcher_shared
import com.eladfinish.bible.contest.toolbar_menu_back_button
import com.eladfinish.bible.contest.ui.icons.AppIcons
import dev.icerock.moko.resources.StringResource

sealed class ToolbarNavigationButtonConfig(
    open val testTag: String,
    open val onClick: () -> Unit,
) {

    sealed class Icon(
        override val onClick: () -> Unit,
        override val testTag: String,
        val icon: ToolbarIcon,
        val contentDescription: StringResource? = null,
    ) : ToolbarNavigationButtonConfig(testTag, onClick)

    sealed class Text(
        onClick: () -> Unit,
        testTag: String,
        open val text: String,
        open val enabled: Boolean,
    ) : ToolbarNavigationButtonConfig(testTag, onClick)

}

data class ToolbarBackButtonConfig(
    override val onClick: () -> Unit,
    override val testTag: String = "toolbar_navigation_button",
) : ToolbarNavigationButtonConfig.Icon(
    testTag = testTag,
    onClick = onClick,
    icon = ToolbarIcon.VectorIcon(imageVector = Icons.AutoMirrored.Filled.ArrowBack),
    contentDescription = SharedRes.strings.toolbar_menu_back_button,
)

data class ToolbarMenuButtonConfig(
    override val onClick: () -> Unit,
    override val testTag: String = "toolbar_navigation_button",
) : ToolbarNavigationButtonConfig.Icon(
    testTag = testTag,
    onClick = onClick,
    icon = ToolbarIcon.VectorIcon(imageVector = AppIcons.MenuOpen),
)

data class ToolbarCloseButtonConfig(
    override val onClick: () -> Unit,
    override val testTag: String = "toolbar_navigation_button",
) : ToolbarNavigationButtonConfig.Icon(
    testTag = testTag,
    onClick = onClick,
    icon = ToolbarIcon.VectorIcon(imageVector = Icons.AutoMirrored.Filled.ExitToApp),
)

data class ToolbarTextButtonConfig(
    override val onClick: () -> Unit,
    override val text: String,
    override val enabled: Boolean = true,
    override val testTag: String = "toolbar_navigation_button",
) : ToolbarNavigationButtonConfig.Text(
    testTag = testTag,
    onClick = onClick,
    text = text,
    enabled = enabled
)

data class ToolbarAppIconButtonConfig(
    override val onClick: () -> Unit,
    override val testTag: String = "toolbar_navigation_button",
) : ToolbarNavigationButtonConfig.Icon(
    testTag = testTag,
    onClick = onClick,
    icon = ToolbarIcon.MokoImageIcon(SharedRes.images.ic_launcher_shared),
)
